module.exports = __webpack_public_path__ + "media/images/ui__warning-5cf55643bc05ed42f09e5e028c445a6d.png";